import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs/Subscription";
import { LoaderService } from "@app/services/shared/loader.service";
import { LoaderState } from "@app/models/common/loaderState";
import { Customer } from "@app/models/customer-registration/CustomerModel";
import { ApiResponse } from "@app/models/OTPResult";
import { ToastrService } from "../../../../node_modules/ngx-toastr";
import { CustomerService } from "@app/services/customer-registration/customer.service";
import { LocationInfoDetail } from "@app/models/ProfileDetailsModel";
import { AppSettings } from "@app/common/app-setting";
import { ProfileDetailsService } from "@app/services/customerProfile/profile-details.service";
import {
  Country,
  CustomerSubTypes,
  ValueTypeGroupEnum,
} from "@app/common/app-enum";
import { NgForm } from "../../../../node_modules/@angular/forms";
import { Router } from "@angular/router";
import { AuthenticationService } from "@app/services/authentication/authentication.service";
import { AutharizedEndPointService } from "@app/services/base-service/autharized-endpoint.service";
import * as jsPDF from "jspdf";
import { VehicleDetailsService } from "@app/services/vehicleDetails/vehicledetails.service";
import { ValueTypeService } from "@app/services/valueType/valuetype.service";
import { ValueType } from "@app/common/valuetype";
import { VehicleDetailModel } from "@app/models/VehicleDetailModel";

@Component({
  selector: "customer-prelogin-default",
  templateUrl: "pre-login-default.component.html",
  styleUrls: ["pre-login.component.scss"],
})
export class CustomerPreloginDefaultComponent implements OnInit {
  countNumberOfVehicles: number = 0;
  vehicleList = new Array<VehicleDetailModel>();
  vehicletype: number;
  vehiclemake: number;
  VehicleMake: Array<ValueType>;
  VehicleType: Array<ValueType>;
  showvehicledetails: VehicleDetailModel = new VehicleDetailModel();
  customerinfo = new Customer();
  fleetClusterTitle: string;
  fleetClusterImage: string;
  errorMessage: string;
  errorMessageForAlphabets: string;
  errorMessages: string;
  errorMessageForFleetCard: string;
  errorMessageForOtp: string;
  errorMessageForMobileNo: string;
  errorStatus = false;
  registrationDate = Date.now();
  stateName: string;
  cityName: string;
  registrationNumber: string;
  errorMessageyear: string;
  yearMessage: string;
  currentYear = new Date();
  errorNoOfCards: string = "";
  //Retail Customer
  retailCustomerModalOpen = false; //For all
  retailCustomerVerifyMobileModalOpen = false;
  retailCustomerCardModalOpen = false;
  retailCustomeractivateCardsModalsOpen = false;

  //Fleet Customer
  fleetCustomerModalOpen = false; //For all
  fleetCustomerVerifyMobileModalOpen = false;
  fleetCustomerProfileModalOpen = false;
  fleetCustomerVehicleCardModalOpen = false;
  fleetCustomerLoginInfoModalOpen = false;
  fleetCustomerActivateCardModalOpen = false;
  confirmPassword: string = null;
  cardFee: number;
  apiResponse = new ApiResponse();
  stateList = new Array<LocationInfoDetail>();
  cityList = new Array<LocationInfoDetail>();
  CountryId: number;
  stateId: number;
  cardPrice: number = 0;
  UploadedImageName: string = "";
  fidx = 1;
  serverUrl = `${AppSettings.API_ENDPOINT + "/Files/UploadedImage/"}`;
  invalidFileTypeErrorMessage: string = "";
  photoPath: string;
  isChecked = true;
  isDeclarationChecked = true;
  imageUrls = [
    // { url: 'assets/images/prelogin_img/slide1.jpg' },
    // { url: 'assets/images/prelogin_img/slide2.jpg' },
    // { url: 'assets/images/prelogin_img/slide3.JPG' },
    // { url: 'assets/images/prelogin_img/slide4.jpg' }
    { url: "assets/images/prelogin_img/slide1.png" },
   // { url: "assets/images/prelogin_img/slide2.png" },
    // { url: "assets/images/prelogin_img/slide3.png" },
    // { url: "assets/images/prelogin_img/slide4.jpg" },
  ];
  constructor(
    private CustomerService: CustomerService,
    private profileDetailsService: ProfileDetailsService,
    private toastr: ToastrService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private vehicledetailsService: VehicleDetailsService,
    private valuetypesService: ValueTypeService
  ) {
    this.apiResponse.Status = false;
  }

  ngOnInit() {
    localStorage.clear();
    this.bindDropDownVehicleMake();
    this.bindDropDownVehicleType();
    this.onFilterChange();
    this.onDeclarationChkChange();
    this.customerinfo.ContactDetails.IsEmail = true;
    this.customerinfo.ContactDetails.IsSMS = true;
    this.customerinfo.isSms = true;
  }

  //Retail and Fleet Customer both
  getMobileNoOTP(mobileNumber) {
    // debugger
    this.CustomerService.getOTP(mobileNumber).subscribe((data) => {
      this.apiResponse = JSON.parse(JSON.stringify(data));
      if (this.apiResponse != null && this.apiResponse.Status) {
        this.toastr.success(this.apiResponse.SuccessMessage);
      } else {
        this.toastr.error(this.apiResponse.ErrorMessage);
      }
    });
  }

  resendMobileNoOTP(resendmobileotp) {
    this.CustomerService.resendMobileOTP(resendmobileotp).subscribe((data) => {
      this.apiResponse = JSON.parse(JSON.stringify(data));
      if (this.apiResponse != null && this.apiResponse.Status) {
        this.toastr.success(this.apiResponse.SuccessMessage);
      } else {
        this.toastr.error(this.apiResponse.ErrorMessage);
      }
    });
  }

  validation(event: any) {
    const pattern = /[0-9\ ]/;
    this.errorStatus = false;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar) && event.keyCode != 8) {
      this.errorMessage = "Enter only numbers";
      this.errorStatus = true;
      event.preventDefault();
    } else {
      this.errorMessage = null;
    }
  }

  validationForCards(event: any) {
    const pattern = /((?!(0))[0-9\ ])/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar) && event.keyCode != 8) {
      this.errorMessageForMobileNo = "Enter only numbers accept 0";
      event.preventDefault();
    } else {
      this.errorMessageForMobileNo = null;
    }
  }

  // validationForMobileNo(event: any) {
  //     const pattern=/^[6789]\d{9}$/;
  //     let inputChar = String.fromCharCode(event.charCode);
  //     if (!pattern.test(inputChar) && event.keyCode != 8) {
  //         this.errorMessageForMobileNo = "Mobile no. must start from 6/7/8/9 and should be of 10 digits";
  //         event.preventDefault();
  //     }
  //     else {
  //         this.errorMessageForMobileNo = null;
  //     }
  // }

  validationForOTP(event: any) {
    const pattern = /^\d[0-9]*$/;
    //this.errorStatus=false;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar) && event.keyCode != 8) {
      this.errorMessageForOtp = "Enter only numbers";
      this.errorStatus = true;
      //event.preventDefault();
    } else {
      this.errorMessageForOtp = null;
    }
  }

  // validationForName(event: any) {
  //     this.customerinfo.Name = event;
  // }

  //Retail Customer
  showRetailCustomerModal(ev: UIEvent) {
    // debugger
    this.retailCustomerModalOpen = true;
    this.retailCustomerVerifyMobileModalOpen = true;
    ev.stopPropagation();
    document.body.style.overflowY = "hidden";
  }

  hideRetailCustomerModal(form: NgForm) {
    this.retailCustomerModalOpen = false;
    this.retailCustomerVerifyMobileModalOpen = false;
    this.retailCustomerCardModalOpen = false;
    this.retailCustomeractivateCardsModalsOpen = false;

    // Reset form's value in the customer modal
    this.customerinfo = new Customer();
    this.apiResponse = new ApiResponse();
    this.apiResponse.Status = false;
    form.reset();
    // this.ngOnInit();
    //  window.location.reload();
    document.body.style.overflowY = "auto";
  }

  validationForAlphabets(event: any) {
    const Pattern = /^[a-zA-Z ]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!Pattern.test(inputChar) && event.keyCode != 8) {
      this.errorMessageForAlphabets = "Enter only alphabets";
      event.preventDefault();
    } else {
      this.errorMessageForAlphabets = null;
    }
  }

  // validationForRetailCard(event: any) {
  //     const cardPattern = /^[1-5]$/;
  //     let inputChar = String.fromCharCode(event.charCode);
  //     if (!cardPattern.test(inputChar) && event.keyCode != 8) {
  //         this.errorMessages = "Maximum 5 no. of cards are allowed";
  //         event.preventDefault();
  //     }
  //     else {
  //         this.errorMessages = null;
  //     }
  // }

  verifyRetailMobileNoOTP(mobileNumber, otp) {
    this.CustomerService.verifyOTP(mobileNumber, otp).subscribe((data) => {
      const result = JSON.parse(JSON.stringify(data));
      if (result != null && result == true) {
        this.toastr.success("OTP verified successfully");
        this.retailCustomerVerifyMobileModalOpen = false;
        this.retailCustomerCardModalOpen = true;
      } else if (result != null && result == false) {
        this.toastr.error("Invalid OTP");
      }
    });
  }

  registerRetailCustomer() {
    // debugger
    this.customerinfo.FleetCardMappingVM = this.vehicleList;
    console.log(this.customerinfo.FleetCardMappingVM);
    console.log(this.customerinfo.SubCategoryTypeId);
    this.CustomerService.registerRetailCustomer(this.customerinfo).subscribe(
      (data) => {
        this.apiResponse = JSON.parse(JSON.stringify(data));
        this.retailCustomerVerifyMobileModalOpen = false;
        this.retailCustomerCardModalOpen = false;
        this.retailCustomeractivateCardsModalsOpen = true;
      }
    );
  }

  calculateRetailCardPrice(event) {
    // debugger
    this.cardPrice = 118 * event;
  }

  refreshPage(): void {
    window.location.reload();
  }
  showFleetCustomerModal(ev: UIEvent) {
    this.fleetClusterTitle = "Fleet";
    this.fleetClusterImage = "assets/images/prelogin_img/fleetCard1.png";
    this.customerinfo.SubCategoryTypeId = CustomerSubTypes.FleetOwner;
    this.FleetAndClusterCustomerModal(ev);
    document.body.style.overflowY = "hidden";
  }
  showClusterCustomerModal(ev: UIEvent) {
    // debugger
    this.fleetClusterTitle = "Cluster";
    this.fleetClusterImage = "assets/images/prelogin_img/cluster_card.png";
    this.customerinfo.SubCategoryTypeId = CustomerSubTypes.ClusterBusOwner;
    this.FleetAndClusterCustomerModal(ev);
    document.body.style.overflowY = "hidden";
  }

  retailCardPrevious() {
    this.retailCustomerVerifyMobileModalOpen = true;
    this.retailCustomerCardModalOpen = false;
  }
  //     retailActivateCardPrevious()
  //     {
  //         this.retailCustomerCardModalOpen=true;
  // this.retailCustomeractivateCardsModalsOpen=false;
  //     }

  //Fleet Customer

  fleetCardPrevious() {
    this.fleetCustomerProfileModalOpen = true;
    this.fleetCustomerVehicleCardModalOpen = false;
  }
  fleetLogiInfoPrevious() {
    this.fleetCustomerVehicleCardModalOpen = true;
    this.fleetCustomerLoginInfoModalOpen = false;
  }
  FleetAndClusterCustomerModal(ev: UIEvent) {
    this.fleetCustomerModalOpen = true;
    this.fleetCustomerVerifyMobileModalOpen = true;
    ev.stopPropagation();
  }

  hideFleetCustomerModal(form: NgForm) {
    this.fleetCustomerModalOpen = false;
    this.fleetCustomerVerifyMobileModalOpen = false;
    this.fleetCustomerProfileModalOpen = false;
    this.fleetCustomerVehicleCardModalOpen = false;
    this.fleetCustomerLoginInfoModalOpen = false;
    this.fleetCustomerActivateCardModalOpen = false;
    // Reset form's value in the customer modal
    this.customerinfo = new Customer();
    this.apiResponse = new ApiResponse();
    this.apiResponse.Status = false;
    form.reset();
    // this.ngOnInit();
    //window.location.reload();
    document.body.style.overflowY = "auto";
  }

  validationForFleetCard(event: any) {
    const pattern = /[0-9\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar) && event.keyCode != 8) {
      this.errorMessageForFleetCard = "Enter only numbers";
      event.preventDefault();
    } else {
      this.errorMessageForFleetCard = null;
    }
  }

  verifyFleetMobileNoOTP(mobileNumber, otp) {
    this.CustomerService.verifyOTP(mobileNumber, otp).subscribe((data) => {
      const result = JSON.parse(JSON.stringify(data));
      if (result != null && result == true) {
        this.toastr.success("OTP verified successfully");
        this.fleetCustomerVerifyMobileModalOpen = false;
        this.fleetCustomerProfileModalOpen = true;
        this.CountryId = Country.India;
        this.selectState(this.CountryId);
      } else if (result != null && result == false) {
        this.toastr.error("Invalid OTP");
      }
    });
  }

  selectState(countryId) {
    // debugger
    this.profileDetailsService.getLocationData(countryId).subscribe((data) => {
      this.stateList = JSON.parse(JSON.stringify(data));
      this.selectCity(this.customerinfo.Address.StateId);
    });
  }

  selectCity(stateId) {
    this.profileDetailsService.getCityData(stateId).subscribe((data) => {
      this.cityList = JSON.parse(JSON.stringify(data));
    });
  }
  registerFleetCustomer() {
    // debugger
    this.customerinfo.FleetCardMappingVM = this.vehicleList;
    console.log(this.customerinfo.FleetCardMappingVM);
    this.CustomerService.registerFleetCustomer(this.customerinfo).subscribe(
      (data) => {
        this.apiResponse = JSON.parse(JSON.stringify(data));
        if (this.apiResponse.ErrorMessage != null) {
          this.toastr.error(this.apiResponse.ErrorMessage);
        } else {
          this.fleetCustomerVerifyMobileModalOpen = false;
          this.fleetCustomerProfileModalOpen = false;
          this.fleetCustomerVehicleCardModalOpen = false;
          this.fleetCustomerLoginInfoModalOpen = false;
          this.fleetCustomerActivateCardModalOpen = true;
          this.registrationNumber = this.apiResponse.SuccessMessage;
        }
      }
    );
  }

  calculateFleetCardPrice(event) {
    if (event <= 200) {
      this.cardFee = 100;
      this.cardPrice = (this.cardFee + (18 / 100) * 100) * event;
    } else {
      this.cardFee = 75;
      this.cardPrice = (this.cardFee + (18 / 100) * 75) * event;
    }
  }

  fleetCustomerProfileNext() {
    this.stateName = this.stateList.find(
      (x) => x.LocationId == this.customerinfo.Address.StateId
    ).LcoationName;
    this.cityName = this.cityList.find(
      (x) => x.LocationId == this.customerinfo.Address.CityId
    ).LcoationName;

    this.fleetCustomerVerifyMobileModalOpen = false;
    this.fleetCustomerProfileModalOpen = false;
    this.fleetCustomerVehicleCardModalOpen = true;
  }

  fleetVehicleCardsNext() {
    this.fleetCustomerVerifyMobileModalOpen = false;
    this.fleetCustomerProfileModalOpen = false;
    this.fleetCustomerVehicleCardModalOpen = false;
    this.fleetCustomerLoginInfoModalOpen = true;
  }

  printStatement() {
    let printContents, popupWin;
    printContents = document.getElementById("printdiv").innerHTML;
    popupWin = window.open("", "_blank", "top=0,left=0,height=100%,width=auto");
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Registration Form</title>
          <style>
          //........Customized style.......
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`);
    popupWin.document.close();
  }

  finish() {
    window.location.reload();
  }

  onFilterChange() {
    this.isChecked = !this.isChecked;
  }
  onDeclarationChkChange() {
    this.isDeclarationChecked = !this.isDeclarationChecked;
  }
  bindDropDownVehicleMake() {
    this.valuetypesService
      .getValueType(ValueTypeGroupEnum.VehicleMake)
      .subscribe((data) => {
        this.VehicleMake = JSON.parse(JSON.stringify(data));
      });
  }

  bindDropDownVehicleType() {
    this.valuetypesService
      .getValueType(ValueTypeGroupEnum.VehicleType)
      .subscribe((data) => {
        this.VehicleType = JSON.parse(JSON.stringify(data));
      });
  }
  addvehicles() {
    if (
      this.customerinfo.NoOfCardsRequired <= this.countNumberOfVehicles ||
      this.customerinfo.NoOfCards <= this.countNumberOfVehicles
    ) {
      if (this.customerinfo.NoOfCardsRequired != undefined)
        this.errorNoOfCards =
          "Enter " +
          this.customerinfo.NoOfCardsRequired +
          " Vehicle details and Click Next";
      else if (this.customerinfo.NoOfCards != undefined)
        this.errorNoOfCards =
          "Enter " +
          this.customerinfo.NoOfCards +
          " Vehicle details and Click Next";
    } else if (
      this.customerinfo.NoOfCardsRequired > this.countNumberOfVehicles ||
      this.customerinfo.NoOfCards > this.countNumberOfVehicles
    ) {
      this.errorNoOfCards = "";
      for (let vehicleMake of this.VehicleMake) {
        if (this.showvehicledetails.VehicleMake == vehicleMake.ValueTypeId) {
          this.showvehicledetails.VehicleMakeText = vehicleMake.Name;
        }
      }
      for (let vehicleType of this.VehicleType) {
        if (this.showvehicledetails.VehicleType == vehicleType.ValueTypeId) {
          this.showvehicledetails.VehicleTypeText = vehicleType.Name;
        }
      }

      this.vehicleList.push(this.showvehicledetails);
      this.showvehicledetails = new VehicleDetailModel();
      this.countNumberOfVehicles = this.vehicleList.length;
    }
  }
  validationForYearAdd(event: any) {
    const pattern = /[0-9\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar) && event.keyCode != 8) {
      this.errorMessageyear = "Enter only numbers";
      event.preventDefault();
    } else {
      this.errorMessage = null;
    }
  }

  getYear() {
    if (
      this.currentYear.getFullYear() <
      this.showvehicledetails.YearOfRegistration
    ) {
      this.yearMessage = "Year should not be greater than current year";
    } else {
      this.yearMessage = " ";
    }
  }
  clickOutlet() {
    var el = document.getElementById("nav-outlet");
    el.click();
  }

  // termsAndConditionsPage(event) {
  //     event.preventDefault();
  //     this.router.navigate(['termsandconditions']);
  // }
}



// WEBPACK FOOTER //
// ./src/app/components/customer-pre-login/pre-login-default.component.ts